import React, { useState } from 'react';

const terms = [
    ['1. Agreement to use JumpTake', 'By accessing or using JumpTake, you agree to these Terms and Conditions. If you do not agree, please do not use the platform.'],
    ['2. Professional and respectful use', 'JumpTake is a professional career platform. Treat every person with respect. Abusive, hateful, threatening, discriminatory, harassing, or sexually explicit language and behaviour are not tolerated.'],
    ['3. Safe and lawful content', 'Do not post illegal activity, fraud, exploitation, nudity or sexual content, graphic violence, or material that infringes another person’s rights. Job posts, profiles, resumes, messages, media, and comments must be truthful and relevant to careers or hiring.'],
    ['4. Content checks and warnings', 'JumpTake may automatically mask offensive language, show a warning, and screen posted text and images for unsafe content. Automated checks support moderation and do not replace your responsibility for what you submit.'],
    ['5. Account responsibility and enforcement', 'Keep your account secure and provide accurate information. We may remove content, restrict features, suspend, or permanently close an account for serious or repeated breaches of these Terms, especially where user safety or the law is involved.'],
    ['6. Reports and feedback', 'You can report a problem or suggest an improvement from About JumpTake. We may review reports to protect the community and improve the service.'],
    ['7. Privacy and service changes', 'Personal information is handled under our privacy practices to provide account, job, application, assessment, and messaging features. We may update the service or these Terms when needed to protect users, comply with law, or maintain the platform.']
];

export const TermsAndConditionsModal = ({ open, onClose, warningMessage = '' }) => {
    if (!open) return null;

    return (
        <div className="terms-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="terms-modal-title">
            <section className="terms-modal">
                <header className="terms-modal-header">
                    <h2 id="terms-modal-title">Terms and Conditions</h2>
                    <button type="button" className="terms-modal-close" onClick={onClose} aria-label="Close terms">×</button>
                </header>
                <div className="terms-modal-body">
                    {warningMessage && <p className="terms-safety-warning" role="alert">{warningMessage}</p>}
                    {terms.map(([heading, copy]) => (
                        <React.Fragment key={heading}>
                            <h3>{heading}</h3>
                            <p>{copy}</p>
                        </React.Fragment>
                    ))}
                </div>
                <button type="button" className="settings-button primary terms-modal-accept" onClick={onClose}>Continue</button>
            </section>
        </div>
    );
};

const TermsAgreement = ({ accepted, onAcceptedChange, disabled = false }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="terms-agreement">
            <label className="gl-checkbox">
                <input type="checkbox" className="gl-checkbox__input" checked={accepted} onChange={(event) => onAcceptedChange(event.target.checked)} disabled={disabled} />
                <span className="gl-checkbox__box" aria-hidden="true">
                    <svg className="gl-checkbox__check" viewBox="0 0 24 24" fill="none">
                        <path d="M5 12.5 10 17l9-10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </span>
                <span className="gl-checkbox__label">
                    <button type="button" className="terms-inline-button" onClick={(event) => { event.preventDefault(); setIsOpen(true); }}>
                        Terms and Conditions
                    </button>
                </span>
            </label>
            <TermsAndConditionsModal open={isOpen} onClose={() => setIsOpen(false)} />
        </div>
    );
};

export default TermsAgreement;
